// Category / agreement constants for the Partner Registration wizard.
// The category set MUST stay in sync with backend `PARTNER_CATEGORIES`.

export const PARTNER_CATEGORIES = [
  { value: "franchise_partner",           label: "Franchise Partner",             partner_type: "franchise" },
  { value: "arn_holder",                  label: "ARN Holder",                    partner_type: "professional" },
  { value: "nism_va_certified",           label: "NISM V-A Certified",            partner_type: "professional" },
  { value: "chartered_accountant",        label: "Chartered Accountant",          partner_type: "professional" },
  { value: "insurance_partner",           label: "Insurance Partner",             partner_type: "professional" },
  { value: "financial_products_partner",  label: "Financial Products Partner",    partner_type: "professional" },
  { value: "education_consultant",        label: "Education Consultant",          partner_type: "professional" },
  { value: "study_abroad_consultant",     label: "Study Abroad Consultant",       partner_type: "professional" },
  { value: "mbbs_abroad_consultant",      label: "MBBS Abroad Consultant",        partner_type: "professional" },
  { value: "college_admission_partner",   label: "College Admission Partner",     partner_type: "professional" },
  { value: "independent_referral_partner",label: "Independent Referral Partner",  partner_type: "professional" },
  { value: "other_professional",          label: "Other Professional",            partner_type: "professional" },
];

export const AGREEMENT_KEYS = [
  { key: "partner_agreement",     label: "MIRO One Partner Agreement" },
  { key: "terms",                 label: "Terms and Conditions" },
  { key: "privacy",               label: "Privacy Policy" },
  { key: "data_processing",       label: "Data-Processing Consent" },
  { key: "membership_policy",     label: "Membership Policy" },
  { key: "commission_policy",     label: "Commission and Payout Policy" },
  { key: "no_guarantee",          label: "No-Guaranteed-Income Declaration" },
  { key: "no_misselling",         label: "No-Mis-selling Declaration" },
  { key: "client_consent",        label: "Client-Consent Responsibility" },
  { key: "refund_policy",         label: "Refund and Cancellation Policy" },
  { key: "clawback_policy",       label: "Clawback Policy" },
  { key: "product_eligibility",   label: "Product-Eligibility Declaration" },
  { key: "code_of_conduct",       label: "Code of Conduct" },
];

export const AGREEMENT_VERSION = "v1.0";

/** Which professional fields to show for a given primary category. Keep in
 * sync with the wizard step 3. */
export const PROFESSIONAL_FIELDS_BY_CATEGORY = {
  arn_holder:                { arn: true, nism: true, gstin: true, org: true, exp: true },
  nism_va_certified:         { nism: true, org: true, exp: true },
  chartered_accountant:      { prof_reg: true, gstin: true, org: true, exp: true },
  insurance_partner:         { insurance_appt: true, posp: true, org: true, exp: true },
  financial_products_partner:{ arn: true, gstin: true, org: true, exp: true },
  education_consultant:      { org: true, exp: true },
  study_abroad_consultant:   { org: true, exp: true },
  mbbs_abroad_consultant:    { org: true, exp: true },
  college_admission_partner: { org: true, exp: true },
  independent_referral_partner: { exp: true },
  other_professional:        { org: true, exp: true, gstin: true },
  franchise_partner:         { org: true, exp: true, gstin: true, business_pan: true },
};
